// const modalBtn = document.querySelector('[data-toggle="modal"]')
// const loginBtn = document.querySelector('[data-target="#login"]')
// const registerBtn = document.querySelector('[data-target="#register"]')
// const fpwBtn = document.querySelector('[data-target="#forgotten-password"]')
// const toLoginBtn = document.getElementById('toLogin')
//
// modalBtn.addEventListener('click', function(e) {
//     loginBtn.click()
// })
//
// loginBtn.addEventListener('click', function(e) {
//     fpwBtn.classList.remove('active')
//     // loginBtn.classList.add('active')
// })
//
// fpwBtn.addEventListener('click', function(e) {
//     loginBtn.classList.remove('active')
//     toLoginBtn.classList.remove('active')
// })
//
// toLoginBtn.addEventListener('click', function(e) {
//     fpwBtn.classList.remove('active')
//     loginBtn.classList.add('active')
// })


$('.login-modal').click(function(e){
  e.preventDefault();
  var modalUrl = $(this).data('modal-href');
  showModal('#login-modal', modalUrl);
});
